<template>
    <div class="baidu-map-page" @click="inputBlur">
      <div class="search-box" v-if="cantEdit">
        <span :class="['btn-drop',{on:isDrop}]" @click="isDrop=!isDrop">
          <b>{{form.city}}</b>
        </span>
        <input 
          id="searchId"
          class="search" 
          type="text" 
          v-model.trim="address" 
          placeholder="输入您想要的地址" 
          @keydown="isConfirm=false;" 
          @focus="inputFocus"
          @click.stop
        >
        <i class="el-icon el-icon-error icon-clear" v-show="address" @click="address=''"></i>
        <i class="el-icon el-icon-search icon-search" @click="inputFocus"></i>
        <button class="submit-btn" v-show="!isDrop" @click="submit">确定</button>
        <ul class="search-result" v-if="showResult" @click.stop>
          <li v-for="(item,index) in searchResult" :key="index" @click="choose(item)" @mouseover="hover(item)">
            <i class="icon el-icon el-icon-search"></i>
            <div class="name">{{item.title}}</div>
            <div class="desc">{{item.address}}</div>
          </li>
          <li class="no-data" v-if="searchResult.length==0">没有搜索结果</li>
        </ul>
        <div class="local-popover" v-show="isDrop">
          <div class="local-wrapper" ref="scroll" @scroll="scroll">
            <div class="scroll-inner">
              <div class="location">当前定位城市 {{localCity}}</div>
              <div class="module-title">常用城市</div>
              <ul class="city-modules">
                <li v-for="(item,index) in usualCityList" :key="index" @click="pickCity(item)">{{item.AreaName}}</li>
              </ul>
              <div class="module-title">热门城市</div>
              <ul class="city-modules">
                <li v-for="(item,index) in hotCityList" :key="index" @click="pickCity(item)">{{item.AreaName}}</li>
              </ul>
              <ul class="letters">
                <li 
                  v-for="(item,index) in letterList" 
                  :class="{on:currentLetter==item}" 
                  :key="index"
                  @click="tapLetter(item)"
                >{{item}}</li>
              </ul>
              <div class="province-list" v-for="(item,index) in provinceList" :key="index">
                <div class="province-name">
                  <i class="letter" :ref="item.Province.FirstLetter">{{item.Province.FirstLetter}}</i>
                  {{item.Province.AreaName}}
                </div>
                <ul class="city-list">
                  <li v-for="city in item.CityList" :key="city.Id" @click="pickCity(city)">{{city.AreaName}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ul class="search-result" v-if="showCityList" @click.stop>
          <li v-for="(item,index) in cityResult" :key="index" @click="pickCity(item)">
            <i class="icon el-icon el-icon-search"></i>
            <div class="name">{{item.AreaName}}</div>
          </li>
        </ul>
      </div>
      
      <div class="map-container" id="map-container" :style="`height: ${mapContainerH}`">
      </div>
    </div>
  </template>
  
  <script>
  import AMapLoader from '@amap/amap-jsapi-loader'
  import {GetSelectCityView,getLocationCity, GetGaodeKey} from '@/service/job.js'
  import {mapState} from 'vuex'
  export default {
      name: 'baiduMap',
      props: {
        pickedAddress: {
          type: Object,
          default: ()=> {}
        },
        pickedAList: {
          type: Array,
          default: ()=> []
        },
        cantEdit: {
          type: Boolean,
          default: false
        },
        mapContainerH: {
          type: String,
          default: '100%'
        },
        mapContainer: {
          type: String,
          default: 'map-container'
        },
      },
      data() {
          return {
              map: null,
              autoOptions: {
                  input: 'searchId' //绑定的搜索关键字的input标签ID，用这个注册
              },
              auto: null,
              userInput: '', //绑定的搜索关键字的的内容
              placeSearch: null,
              searchHere: null, //根据搜索组件搜索到以后的地点信息
              marker: null,
  
              // 左上角样式
              localCity:'',
              mapPoint:null,
              cityWord:'',
              isDrop:false,
              address:'',
              keyWord:'',
              isConfirm:false,
              provinceList:[],//省市区列表
              hotCityList:[],//热门城市
              usualCityList:[],//常用地址
              searchResult:[],//搜索结果
              currentLetter:'A',
              showResult:false,
              showCityList:false,
              form:{
                city:'',
                fullAddress:'',
                lat:'',
                lng:'',
              },
              defaultCenter: {
                lng: 113.259356,
                lat: 23.149027
              },
              icon:require('@/assets/map/map-worker.png'),
              iconActive:require('@/assets/map/map-worker-active.png'),
              iconTarget:require('@/assets/map/icon-target.png'),
              keyInfo: {}
          }
      },
      computed: {
        ...mapState({
          userInfo:state=>state.userInfo,
        }),
        letterList(){
          //获取省首字母列表
          let arr=[];
          let obj={};
          for (let i = 0; i < this.provinceList.length; i++) {
            if(!obj[this.provinceList[i].Province.FirstLetter]){
              // 去重
              arr.push(this.provinceList[i].Province.FirstLetter);
              obj[this.provinceList[i].Province.FirstLetter]=1;
            }
          }
          return arr;
        },
        cityResult(){
          //根据搜索文字筛选城市名称
          let arr=[];
          for (let i = 0; i < this.provinceList.length; i++) {
            for (let j = 0; j < this.provinceList[i].CityList.length; j++) {
              let name=this.provinceList[i].CityList[j].AreaName;
              if(this.cityWord!='' && name.indexOf(this.cityWord)!=-1){
                arr.push(this.provinceList[i].CityList[j]);
              }
            }
          }
          return arr;
        },
        loginUserMap() {
          return {
            userType: this.userInfo?this.userInfo.LoginAccountType:0,
            userId: this.userInfo?this.userInfo.LoginAccountId:0
          }
        }
      },
      watch: {
        // 【注意事项】传参过来，若是普通弹框settimeout 50 若不是弹框要settimeout 50
        pickedAddress: {
          handler(newVal, oldVal) {
            if(newVal) {
              if(Object.values(newVal).filter(item=> item).length) {
                console.log("newVal, oldVal 99999999",newVal, oldVal)
                this.map.remove(this.marker);
                this.isConfirm = false;
                if(newVal.cantEdit !== null && newVal.cantEdit !== undefined) {
                  this.cantEdit = newVal.cantEdit;
                }
                this.form = {
                  city: newVal.CityName || '',
                  fullAddress: newVal.FullAddress,
                  lat:Number(newVal.Lat),
                  lng:Number(newVal.Lng),
                  resetIcon: newVal.ResetIcon,
                  resetIconWHL: newVal.ResetIconWHL
                }
                this.address = newVal.FullAddress;
                // 加个setTimeout，保证地图的初始化后再跳转
                // <gaodeMap 不需要加v-if="isShowMap"
                // setTimeout(() => {
                  console.log("等待mounted初始化map后 this.cantEdit",this.cantEdit)
                  // // -------1 初始化地图中心点位置
                  this.setJumpCenter(this.form, newVal.ResetIcon ? 5 : 18)
                  // -------3 指定点加标识
                  this.setPlace(this.form)

                // }, 50);
              }
            }
          },
          deep: true,
          immediate: true
        },
        pickedAList: {
          handler(newVal, oldVal) {
             if(newVal.length) {
              if(!this.map) return;
              // 清除指定点加标识
              console.log("等待mounted初始化map后 newVal, oldVal pickedAList++++++++++",newVal, this.map, this.marker)
              this.map.remove(this.marker);
              this.isConfirm = false;
              newVal.map((msgItem, msgItemIndex)=>{
                if(msgItem.FullAddress || msgItem.Lat){ 
                  if(msgItem.cantEdit !== null) {
                    this.cantEdit = msgItem.cantEdit;
                  }
                  this.address=msgItem.FullAddress;

                  let newItem = {
                    city: msgItem.CityName || '',
                    fullAddress: msgItem.FullAddress,
                    lat:Number(msgItem.Lat),
                    lng:Number(msgItem.Lng),
                    resetIcon: msgItem.ResetIcon,
                    resetIconWHL: msgItem.ResetIconWHL
                  }
                  let noResetIcon = newVal.filter(item=> !item.ResetIcon)
                  let grayResetIcon = newVal.filter(item=> item.ResetIcon === 'icon' || item.ResetIcon === 'iconTarget')
                  if(msgItem.ResetIcon === 'iconActive' || newVal.length == 1) {
                    // -------1 初始化地图中心点位置
                    this.setJumpCenter(newItem, 5, 'noSearch')
                  }else if(noResetIcon.length === newVal.length && msgItemIndex == 0) {
                    this.setJumpCenter(newItem, 5, 'noSearch')
                  }else if(grayResetIcon.length === newVal.length && msgItemIndex == 0) {
                    this.setJumpCenter(newItem, 5, 'noSearch')
                  }
                  // -------3 指定点加标识
                  this.setPlace(newItem)
                }

                
              })
            }
          },
          deep: true,
          immediate: true
        },
        'form.city'(value,old){
          if(value!==old){
            this.mapPoint=null;
            // this.address='';
          }
        },
        address(value){
          //监听输入框地址变化
          if(value){
            this.keyWord=value;
            if(!this.isConfirm){
              console.log("watch address", value)
              this.getSearchOption(this.keyWord)
            }
          }else{
            this.showResult=false;
            this.searchResult=[];
            this.mapPoint=null;
            this.searchHere = null;
            this.placeSearch.clear(); // this.map.clearOverlays();
          }
        },
        cityWord(value){
          if(value!=='' && this.cityResult.length>0){
            this.showCityList=true;
          }else{
            this.showCityList=false;
          }
        }
      },
      created() {
        console.log("created")
      },
      mounted() {
        // 左上角搜索条件下拉列表的初始化
        this.init()
        // 地图的初始化
        console.log("mounted")
        this.initMap(this.defaultCenter)
        // 值1： {
        //   city:"北京市"
        //   fullAddress:""
        //   lat:"39.92"
        //   lng:"116.40"
        // }
        // 值2 destination  =  {
        //   city:"湖州市"
        //   fullAddress:"湖北黄石市辖区新华路"
        //   lat: 30.880897
        //   lng: 120.439892,
        // }
        layer.closeAll('loading'); //关闭加载层
          
      },
      methods: {
        getGaodeKeyFun() {
            return new Promise((resolve, reject)=>{
              GetGaodeKey({KeyType: 1, platform: "pcweb"}).then(res => {
                if(res.Result == 1 && res.Data){
                  this.keyInfo = res.Data;
                  // 获取Key和Sign的同时，设置页面的秘钥 this.keyInfo.Sign
                  window._AMapSecurityConfig = {
                    securityJsCode: this.keyInfo.Sign
                  }
                  resolve()
                }else {
                  this.$message.error(res.Message)
                  reject()
                }
              })
            })
          },
          async initMap(center, zoom= 12) {
            await this.getGaodeKeyFun();
            console.log("initMap 99999999999", center)
            let that = this;
              AMapLoader.load({
                  key:  this.keyInfo.Key, // 申请好的Web端开发者Key，首次调用 load 时必填
                  version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                  plugins: ['AMap.ToolBar', 'AMap.Scale', 'AMap.HawkEye', 'AMap.MapType',
                      'AMap.Geolocation', 'AMap.AutoComplete', 'AMap.PlaceSearch', 
                  ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
              }).then((AMap) => {
                  this.map = new AMap.Map(this.mapContainer, { //设置地图容器id
                      viewMode: "3D", //是否为3D地图模式
                      resizeEnable: true
                  });
                  //构造地点查询类
                  that.placeSearch = new AMap.PlaceSearch({
                      map: that.map,
                  }) 
                 
                  // -------1 初始化地图中心点位置
                  that.setJumpCenter(center,  zoom, 'noSearch')
                  // -------3 指定点加标识
                  that.setPlace(center)
                  //引入高德地图的空间绑定使用
                  that.map.addControl(new AMap.Scale())
                  that.map.addControl(new AMap.ToolBar())
                  that.map.addControl(new AMap.HawkEye())
                  that.map.addControl(new AMap.MapType())
                  // that.map.addControl(new AMap.Geolocation())
                  that.auto = new AMap.AutoComplete(that.autoOptions)
                  
                  
                  // -------4 开启定位
                  that.getGeolocation()
                  that.auto.on('select', that.select)//绑定查询事件
              
              }).catch(e => {
                  console.log(e);
              })
          },
          
          //poi搜索 这里面的这个参数 e 就是搜索以后的地址信息 你可以把它打印出来看一看经纬度什么的都有
          select(e) {
              console.log("e",e)
              // 步骤 1· 2 ·3 start
              this.setPlace(e.poi.location); 
              this.setJumpCenter(e.poi.location)
              this.searchHere = e.poi;   
              // 步骤 1· 2 ·3 end
          },
          //指定点加标识
          setPlace(point){
            console.log("指定点加标识 setPlace 9999999",point)
            // 类型一 若是传过来的是某个工程师的地理位置 要用特殊的图标
            let icon = null;
            if(point.resetIcon) {
              icon = new AMap.Icon({
                size: new AMap.Size(68, 46), // 图标尺寸
                image: this[point.resetIcon], // Icon的图像
                imageSize: point.resetIconWHL ? new AMap.Size(point.resetIconWHL[0], point.resetIconWHL[1]) : new AMap.Size(24, 31), // 根据所设置的大小拉伸或压缩图片
              })
            }

            this.marker = new AMap.Marker({
              icon: icon,
              position: [point.lng, point.lat],
              autoRotation: true,
              draggable: point.resetIcon ? false : true, //点标记可拖拽  
              cursor:'move',   //鼠标悬停点标记时的鼠标样式 
              raiseOnDrag:true //鼠标拖拽点标记时开启点标记离开地图的效果
            });
            
            if(!this.cantEdit) {
              this.marker.on('click', this.markerClick)
            }
             console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@",this.marker, this.map)
            this.marker.setMap(this.map);
            // this.marker.setAnimation('AMAP_ANIMATION_BOUNCE');
          },
          //点击标识
          markerClick(e) {
            var point = e.target._position;
            console.log("点击标识", point)
            let index=-1;
            for (let i = 0; i < this.pickedAList.length; i++) {
              if(point[0]==this.pickedAList[i].Lng && point[1]==this.pickedAList[i].Lat){
                index=i;
              }
            }
            if(index>-1){
              this.$emit("markerClick", index)
            }
          },
          // 设置动画
          marker2Cartoon(){
            console.log("this.marker",this.marker)
            this.marker.setAnimation('AMAP_ANIMATION_BOUNCE'); //设置点标记的动画效果，此处为弹跳效果
          },
          setJumpCenter(point, zoom = 12, noSearch = false) {
            console.log("setJumpCenter  ++++++++++++",point.lat)
            // 有经纬度
            if(point.lng) {
              this.map.setCenter([point.lng, point.lat])
            }else if(point.adcode) { 
              // 没有精确的经纬度，但是有城市的ID
              this.placeSearch.setCity(point.adcode) //依据城市ID搜索
              this.placeSearch.search(point.name) //关键字查询查询
            }
            this.map.setZoom(zoom,true)

            if(noSearch) return;
            if(point.fullAddress) {
              this.getSearchOption(point.fullAddress) //关键字查询查询LocalMap.search(keyWord);
            }else if(point.city) {
              // ------- 有城市
              this.getSearchOption(point.city); //关键字查询查询LocalMap.search(keyWord);
            }
          },
          //关键字查询查询
          getSearchOption(keyWord) {
            if(!this.cantEdit)  return;
            let that = this;
            this.placeSearch.search(keyWord, function(status, result) {
              if (status === 'complete' && result.info === 'OK') {
                  let arr = result.poiList.pois;
                  arr.map(item=>{
                    item.title =  item.name;
                  })
                  that.searchResult = arr;
                  if(that.searchResult.length){
                    that.showResult=true;
                  }
                  console.log('getSearchOption 99999999999',that.searchResult)
  
                }
            }) 
          },
            // 启用显示定位
          getGeolocation() {
            const geolocation = new AMap.Geolocation({
              enableHighAccuracy: true,//是否使用高精度定位，默认:true
              timeout: 10000,          //超过10秒后停止定位，默认：5s
              buttonPosition:'RB',    //定位按钮的停靠位置
              buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
              zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
            });
            this.map.addControl(geolocation)
            geolocation.getCurrentPosition(function(status, result) {
              console.log("启用显示定位 result",result)
              // if (status == 'complete') {
              //   onComplete(result); // 定位成功
              // } else {
              //   onError(result); // 定位失败
              // }
            });
          },
  
  
          
          /////////////////////////////////////左上角搜索条件//////////////////////////////////////////////
          init(){
            //获取省市区
            let userType= this.loginUserMap.userType;
            let userId= this.loginUserMap.userId;
            let params={
              platform :'pcweb'
            }
            if(userType==1){
              params['UserId']=userId;
            }else if(userType==2){
              params['CompanyId']=userId;
            }
            GetSelectCityView(params).then(r=>{
              if(r.Result==1){
                this.provinceList=r.Data.ProvinceCityList || [];
                this.usualCityList=r.Data.FrequentCityList || [];
                this.hotCityList=r.Data.HotCityList || [];
              }
            })
            // 临时隐藏
            //获取IP所在城市
            // let that = this;
            // getLocationCity().then(r=>{
            //   if(r.status==0){
            //     let arr=r.address.split('|');
            //     if(arr.length>3){
            //       this.localCity=arr[2];
            //     }else{
            //       this.localCity='';
            //     }
            //     if(!that.form.city){
            //       that.form.city=that.localCity;
            //     }
            //   }
            // })
          },
          //搜索框聚焦时搜索
          inputFocus(event){
            console.log("inputFocus event", event, this.address)
            this.isConfirm=false;
            if(this.address!==''){
              var keyWord=this.address;
              this.getSearchOption(keyWord); //关键字查询查询LocalMap.search(keyWord);
            }
          },
          inputBlur(){
            this.searchResult=[];
            this.showResult=false;
            // this.isDrop=false;
          },
          //点击字母
          tapLetter (data){
            this.currentLetter=data;
            this.$refs.scroll.scrollTop=this.$refs[data][0].offsetTop-50;
          },
          //选择市
          pickCity(item){
            let newItem ={
              lat:Number(item.Lat),
              lng:Number(item.Lng),
            }
            console.log("pickCity,",newItem)
            this.setJumpCenter(newItem); // this.renderMap();
            this.form.city=item.AreaName;
            this.isDrop=false;
            this.cityWord='';//清空城市列表
            this.address='';
          },
          scroll(){
            let s_top=this.$refs.scroll.scrollTop;
            for (let i = 0; i < this.letterList.length; i++) {
              let l_top=this.$refs[this.letterList[i]][0].offsetTop;
              if(s_top>=l_top-50){
                this.currentLetter=this.letterList[i];
              }
            }
          },
          //确认
          submit(){
            let sHere = this.searchHere
            if(!sHere){
              this.$toast('请输入并选择地址！');
              return;
            }
            let params={
              CityName: sHere.cityname,
              FullAddress: sHere.pname + sHere.cityname + sHere.adname + sHere.name,
              Lat: sHere.location.lat,
              Lng: sHere.location.lng,
            }
            console.log("-----submit=",params)
            this.$emit("gaodemapSubmit", params)
          },
          //选择的点
          choose(item){
            console.log("choose item",item)
            // 步骤 1· 2 ·3 start
            this.setPlace(item.location); 
            this.setJumpCenter(item.location, 18)
            this.searchHere = item;
            // 步骤 1· 2 ·3 end
            this.address=item.title;
            this.form.city=item.cityname;
            this.isConfirm=true;
            this.showResult=false;
          },
          //鼠标停留
          hover(item){
            // console.log("hover item",item)
          },
          destroyed() {
            console.log("destroyed")
            if(this.map){
              this.map.destroy()
            }
          },
           
      },
  
  }
  </script>
  
  <style lang="scss" scoped>
  //  @import '@/styles/map.css';
   @import '@/styles/map.scss';
  .tangram-suggestion{
    max-height: 300px !important;
    overflow-y: auto;
  }
  .baidu-map-page{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    &~#fixedRight{
      display: none;
    }
    .search-box{
      position: absolute;
      left: 10px;
      top: 11px;
      z-index: 9;
      width: 400px;
      height: 60px;
      background-color: #fff;
      border-radius: 4px;
      padding-left: 65px;
      padding-right: 75px;
    }
    .btn-drop{
      width: 53px;
      height: 30px;
      position: absolute;
      left: 8px;
      top: 15px;
      overflow: hidden;
      padding-right: 10px;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      cursor: pointer;
      -webkit-user-select: none;
      b{
        display: block;
        overflow: hidden;
        white-space: nowrap;
        font-weight: normal;
      }
  
      &:after{
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top: 6px solid #ccc;
        margin-top: -3px;
      }
      &.on:after{
        border-top: 5px solid transparent;
        border-bottom: 6px solid #ccc;
        margin-top: -8px;
      }
    }
    .search{
      display: block;
      width: 100%;
      height: 30px;
      background-color: #e5e5e5;
      color: #333;
      font-size: 14px;
      line-height: 18px;
      border-radius: 30px;
      padding: 6px 20px 6px 10px;
      padding-left: 34px;
      margin-top: 15px;
    }
    #mapSearch{
      position: absolute;
      left: 0;
      top: 0;
      visibility: hidden;
    }
    ::placeholder{
      color: #aaa;
    }
    .icon-clear{
      position: absolute;
      right: 80px;
      top: 50%;
      z-index: 9;
      margin-top: -7px;
      font-size: 14px;
      color:#999;
      cursor: pointer;
    }
    .icon-search{
      position: absolute;
      left: 76px;
      top: 23px;
      z-index: 9;
      font-size: 14px;
      color:#999;
    }
    .submit-btn{
      position: absolute;
      right:12px;
      top: 15px;
      width: 48px;
      height: 30px;
      background: rgba(247, 89, 89, 1);
      border-radius: 2px;
      font-family: inherit;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }
    .search-result{
      position: absolute;
      left: 0;
      top: 100%;
      z-index: 99;
      width: 100%;
      max-height: 400px;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      overflow-y: auto;
      border-radius: 4px;
    }
    .search-result li{
      padding: 4px 6px 4px 24px;
      cursor: pointer;
      position: relative;
    }
    .search-result li .icon{
      position: absolute;
      left: 4px;
      top: 6px;
      width: 16px;
      height: 16px;
      color: #ccc;
    }
    .search-result .name{
      font-size: 14px;
      color: #333;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .search-result .desc{
      font-size: 12px;
      color: #999;
      line-height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .search-result li:hover{
      background-color: #f8f8f8;
      color:#f75959;
    }
    .search-result li:hover .name{
      color: #f75959;
    }
    .search-result li:hover .icon{
      color: #f75959;
    }
    #map-container {
      width: 100%;
      height: 100%;
      padding: 0px;
      margin: 0px;
      width: 100%;
      position: absolute;
      z-index: 0;
    }
    .local-popover{
      position: absolute;
      left: 0;
      top: 100%;
      margin-top: 10px;
      z-index: 99;
      width: 400px;
      height: 420px;
      overflow-y: auto;
      border-radius:8px;
      background-color: rgba(255,255,255,0.9);
      box-shadow: 2px 2px 0px 0px rgba(0, 0, 0, 0.09);
      .local-wrapper{
        height: 100%;
        overflow-y: auto;
        padding: 12px 0 10px 20px;
      }
      .location{
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-bottom: 10px;
      }
      .module-title{
        font-size: 14px;
        color: #333;
        line-height: 24px;
        margin-bottom: 10px;
      }
    }
    .city-modules{
      overflow: hidden;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 10px;
      >li{
        float: left;
        width: 70px;
        height: 32px;
        line-height: 32px;
        padding: 0 6px;
        background-color: #e5e5e5;
        color: #333;
        font-size: 14px;
        border-radius: 6px;
        text-align: center;
        margin-right: 15px;
        margin-bottom: 15px;
        white-space: nowrap;
        overflow: hidden;
        -webkit-user-select: none;
        &:active{
          background-color: #f75959;
          color: #fff;
        }
      }
    }
    .letters{
      position: absolute;
      right: 20px;
      top: 10px;
      z-index: 2;
      >li{
        font-size: 14px;
        color: #333;
        line-height: 24px;
        cursor: pointer;
        &.on{
          color: #f75959;
        }
      }
    }
    .province-list{
      .province-name{
        font-size: 16px;
        color: #333;
        line-height: 24px;
        margin-bottom: 10px;
        .letter{
          font-size: 15px;
          color: #999;
          padding-right: 20px;
        }
      }
    }
    .city-list{
      overflow: hidden;
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 10px;
      margin-bottom: 10px;
      >li{
        float: left;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        cursor: pointer;
        margin-right: 20px;
        -webkit-user-select: none;
        &:hover{
          color: #f75959;
        }
      }
    }
    
  }
  
  .amap-sug-result {
    display: none !important;
  }
  </style>